import { render, staticRenderFns } from "./saveRecentNews.vue?vue&type=template&id=5489b572&"
import script from "./saveRecentNews.vue?vue&type=script&lang=js&"
export * from "./saveRecentNews.vue?vue&type=script&lang=js&"
import style0 from "./saveRecentNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports